import {
  viralWidgetCombinesWithSchema,
  viralWidgetDiscountValueSchema,
  viralWidgetSettingsSchema,
} from "@redotech/redo-conversion-core-common/viral/viral-widget";
import * as z from "zod";

export const upsertViralWidget = {
  name: "upsertViralWidget" as const,
  description:
    "Creates or updates the team's singleton Thank You page viral widget config. Enabling it provisions the two Shopify discounts the widget mints through.",
  input: z.object({
    enabled: z.boolean(),
    title: z.string(),
    message: z.string(),
    finePrint: z.string(),
    shareDiscount: viralWidgetDiscountValueSchema,
    rewardDiscount: viralWidgetDiscountValueSchema,
    shareUsageLimit: z.number().int().min(1),
    shareWindowDays: z.number().int().min(1),
    rewardWindowDays: z.number().int().min(1),
    combinesWith: viralWidgetCombinesWithSchema,
  }),
  output: viralWidgetSettingsSchema,
};
